<template>
  <div>
    <div v-if="successMessage" class="alert alert-success" style="color: rgb(5, 20, 48)">
      {{ successMessage }}
    </div>
    <b-card>
      <b-row>
        <div class="col-12 mt-16">
          <b-form @submit.prevent="addUser" v-if="show">
            <!-- Section Header -->
            <div
              style="background-color: rgb(97, 116, 152); height: 32px; border-radius: 4px;"
            >
              <h4
                style="color: rgb(223, 227, 238); margin-left: 5px; font-weight: bold;"
              >
                Slider Information
              </h4>
            </div>

            <div class="row">
              <!-- URL -->
              <div class="col-md-4 col-12">
                <b-form-group label="URL:" label-for="url">
                  <b-form-textarea
                    id="url"
                    placeholder="Enter URL"
                    v-model="url"
                    :state="validateField(url)"
                    rows="2"
                    required
                  ></b-form-textarea>
                  <b-form-invalid-feedback>
                    Please enter a valid URL.
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
              <!-- Profile Picture Upload -->
              <div class="col-md-4 col-12">
                <b-form-group label="Slider Image:" label-for="image">
                  <!-- Drag & Drop Zone -->
                  <div
                    class="border rounded p-3 text-center"
                    style="cursor: pointer; background: #f9f9f9;"
                    @drop.prevent="onDrop"
                    @dragover.prevent
                    @click="$refs.fileInput.click()"
                  >
                    <div v-if="!imagePreview">
                      <i class="fas fa-cloud-upload-alt fa-2x text-muted"></i>
                      <p class="mb-0">Drag & Drop or Click to Upload</p>
                    </div>
                    <div v-else>
                      <img
                        :src="imagePreview"
                        alt="Preview"
                        class="img-thumbnail"
                        style="max-height: 120px;"
                      />
                    </div>
                    <input
                      ref="fileInput"
                      type="file"
                      accept="image/png, image/jpeg"
                      class="d-none"
                      @change="onFileChange"
                    />
                  </div>

                  <small class="text-muted">Only JPG/PNG, Max size: 2MB</small>
                  <div v-if="imageError" class="text-danger mt-1">
                    {{ imageError }}
                  </div>
                </b-form-group>
              </div>
            </div>

            <!-- Submit -->
            <b-button
              type="submit"
              variant="primary"
              class="mb-8 mr-8"
              :disabled="isLoading"
            >
              <span v-if="!isLoading">Submit</span>
              <b-spinner v-else variant="primary" small></b-spinner>
            </b-button>
          </b-form>
        </div>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BSpinner,
  BFormInvalidFeedback,
   BFormTextarea,
} from "bootstrap-vue";
import { BToast } from "bootstrap-vue";
import axios from "../../../axios";
import imageCompression from "browser-image-compression";

export default {
  data() {
    return {
      show: true,
      isLoading: false,
      image: null,
      url: "",
      successMessage: "",
      errorMessage: "",
      imagePreview: null,
      imageError: "",
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BToast,
    BSpinner,
    BFormInvalidFeedback,
     BFormTextarea,
  },
  methods: {
   validateField(value) {
      if (value === null || value === undefined || value === "") return null;
      return value.toString().trim().length > 0;
    },
    async addUser() {
      this.isLoading = true;
      this.imageError = "";

      const formData = new FormData();
      formData.append("image", this.image);
      formData.append("url", this.url);

      axios
        .post("sliderStore", formData)
        .then(() => {
          this.$bvToast.toast("Slider added successfully!", {
            title: "Success",
            variant: "primary",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 5000,
          });
          this.isLoading = false;
          this.$router.push({ name: "ListSlider" });
        })
        .catch((error) => {
          this.errorMessage =
            error.response?.data?.message || "Error adding slider";
          this.isLoading = false;
        });
    },

    async onFileChange(event) {
      const file = event.target.files[0];
      await this.handleFile(file);
    },
    async onDrop(e) {
      const file = e.dataTransfer.files[0];
      await this.handleFile(file);
    },
    async handleFile(file) {
      if (!file) return;

      if (!["image/jpeg", "image/png"].includes(file.type)) {
        this.imageError = "Only JPG/PNG allowed.";
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        this.imageError = "Max size is 2MB.";
        return;
      }

      try {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
        };
        const compressedFile = await imageCompression(file, options);
        this.image = compressedFile;
        this.imagePreview = URL.createObjectURL(compressedFile);
        this.imageError = "";
      } catch (err) {
        console.error("Compression error:", err);
        this.image = file;
        this.imagePreview = URL.createObjectURL(file);
      }
    },
  },
};
</script>
